export const ROUTES = {
  PORTAL: '/',
  MAIN: '/about-us',
  BASKET: '/basket',
  USER_AGREEMENT: '/user-agreement',
  USER_DATA: '/user-data',
  OTHER_GIFTS: '/other-gifts', // will not be used
  PRODUCTS: '/products/:page/:id_product?',
  FOTO: '/products/photos',
  FOTOBOOK: '/products/fotobooks',
  CALENDAR: '/products/calendars',
  GIFT_FACTORY: '/products/gifts',
  POSTCARDS: '/products/postcards',
  INTERIOR_DECOR: '/products/decor',
  MAGNETS: '/products/magnets',
  PHOTO_SOUVENIRS: '/products/souvenirs',
  CLOTHING_WITH_PHOTO: '/products/clothes',
  GIFT_CERTIFICATES: '/products/certificates',
  FOTO_OLD: '/photo',
  FOTOBOOK_OLD: '/fotobooks',
  CALENDAR_OLD: '/calendars',
  GIFT_FACTORY_OLD: '/gift-factory',
  POSTCARDS_OLD: '/postcards',
  INTERIOR_DECOR_OLD: '/decor',
  MAGNETS_OLD: '/magnets',
  PHOTO_SOUVENIRS_OLD: '/photo-souvenirs',
  CLOTHING_WITH_PHOTO_OLD: '/clothing-with-photo',
  GIFT_CERTIFICATES_OLD: '/gift-certificates',
  REDIRECT: '/redirect',
};

export const PRODUCT_PAGES = {
  FOTOS: 'photos',
  FOTOBOOKS: 'fotobooks',
  CALENDARS: 'calendars',
  GIFT_FACTORY: 'gifts',
  POSTCARDS: 'postcards',
  INTERIOR_DECOR: 'decor',
  MAGNETS: 'magnets',
  PHOTO_SOUVENIRS: 'souvenirs',
  CLOTHING_WITH_PHOTO: 'clothes',
  GIFT_CERTIFICATES: 'certificates',
};
